import { render, staticRenderFns } from "./chateau-sigalas-rabaud.vue?vue&type=template&id=2e1ce69d&scoped=true"
import script from "./chateau-sigalas-rabaud.vue?vue&type=script&lang=js"
export * from "./chateau-sigalas-rabaud.vue?vue&type=script&lang=js"
import style0 from "./chateau-sigalas-rabaud.vue?vue&type=style&index=0&id=2e1ce69d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ce69d",
  null
  
)

export default component.exports